import { ancoraPorId, perfilVeiculoPorId } from '../didatico/perfilVeiculo'
import { pontoMundoNoVeiculo } from './referencial'
import type { CenaTabletop, ObjetoTabletop, TransformacaoTabletop } from './tipos'

export const normalizarDirecao = (graus: number) => ((graus % 360) + 360) % 360

export function comDirecao(transformacao: TransformacaoTabletop, graus: number): TransformacaoTabletop {
  if (!Number.isFinite(graus)) return transformacao
  return { ...transformacao, rotacao: [transformacao.rotacao[0], normalizarDirecao(graus) * Math.PI / 180, transformacao.rotacao[2]] }
}

export function pontoDoAlvo(cena: CenaTabletop, alvo: ObjetoTabletop) {
  const local = alvo.vitima?.local
  if (local?.tipo === 'veiculo') {
    const carro = cena.objetos.find(o => o.id === local.idVeiculo)
    if (carro?.veiculo) {
      const ancora = ancoraPorId(perfilVeiculoPorId(carro.veiculo.idPerfil), local.idAncora)
      const escala = carro.transformacao.escala
      return pontoMundoNoVeiculo({ x: ancora.posicao.x * escala[0], y: ancora.posicao.y * escala[1], z: ancora.posicao.z * escala[2] }, carro)
    }
  }
  const [x, y, z] = alvo.transformacao.posicao
  return { x, y, z }
}

export function direcaoParaAlvo(cena: CenaTabletop, origem: ObjetoTabletop, alvo: ObjetoTabletop): number | null {
  const ponto = pontoDoAlvo(cena, alvo)
  const dx = ponto.x - origem.transformacao.posicao[0]
  const dz = ponto.z - origem.transformacao.posicao[2]
  if (Math.hypot(dx, dz) < 0.001) return null
  return normalizarDirecao(Math.atan2(dx, dz) * 180 / Math.PI)
}
